import { createSlice } from "@reduxjs/toolkit";
import { triggerComplianceCampaignAPI } from "../../services/triggerComplianceCampaign";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const triggerComplianceCampaignSlice = createSlice({
  name: "triggerComplianceCampaign",
  initialState: data,
  reducers: {
    triggerComplianceCampaignInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    triggerComplianceCampaignInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "Compliance campaign triggered successfully";
      state.error = "";
    },
    triggerComplianceCampaignInfoFailure(state, action) {
      state.isLoading = false;
      state.data = null;
      state.message = "";
      state.error = action.payload;
    },
    triggerComplianceCampaignInfoReset(state) {
      state.isLoading = false;
      state.data = null;
      state.error = "";
      state.message = "";
    },
  },
});

export const triggerComplianceCampaignHandler = (payload) => async (dispatch) => {
  try {
    dispatch(triggerComplianceCampaignAction.triggerComplianceCampaignInfo());
    const response = await triggerComplianceCampaignAPI(payload);
    dispatch(triggerComplianceCampaignAction.triggerComplianceCampaignInfoSuccess(response));
  } catch (e) {
    const errorMessage = typeof e === "string" ? e : e?.message || "Something went wrong.";
    dispatch(triggerComplianceCampaignAction.triggerComplianceCampaignInfoFailure(errorMessage));
  }
};

export default triggerComplianceCampaignSlice.reducer;
export const triggerComplianceCampaignAction = triggerComplianceCampaignSlice.actions;
